// extracted by css-extract-rspack-plugin
export default {"contentPreview":"EmbeddedContentPreview-module__contentPreview__BrvFQ"};